import { authenticated } from '../../helpers/auth-header';
import insighttAPI from '../clients/insightt-api-client';
import { shiftsEndpoints } from '../endpoints';

const getAllShifts = () => authenticated(insighttAPI, { fromCache: false }).get(shiftsEndpoints.getShiftsAPI());

const getUserShifts = (day) => authenticated(insighttAPI).get(shiftsEndpoints.getShiftsAPI(day));

const getShiftDetails = (shiftId) => authenticated(insighttAPI).get(shiftsEndpoints.getShiftDetailsAPI(shiftId));

const createShift = (payload) => authenticated(insighttAPI).post(shiftsEndpoints.createShiftAPI(), payload);

const updateShift = (shiftId, payload) =>
  authenticated(insighttAPI).put(shiftsEndpoints.updateShiftAPI(shiftId), payload);

const updateShiftSummary = (shiftId, payload) =>
  authenticated(insighttAPI).put(shiftsEndpoints.updateShiftSummaryAPI(shiftId), payload);

const deleteShift = (shiftId) => authenticated(insighttAPI).delete(shiftsEndpoints.deleteShiftAPI(shiftId));

const createIndividualCommissions = (shiftId, payload) =>
  authenticated(insighttAPI).post(shiftsEndpoints.individualCommissionsCRUDAPI(shiftId), payload);

const updateIndividualCommissions = (shiftId, payload) =>
  authenticated(insighttAPI).put(shiftsEndpoints.individualCommissionsCRUDAPI(shiftId), payload);

const deleteIndividualCommissions = (shiftId) =>
  authenticated(insighttAPI).delete(shiftsEndpoints.individualCommissionsCRUDAPI(shiftId));

const createTeamCommissions = (shiftId, payload) =>
  authenticated(insighttAPI).post(shiftsEndpoints.teamCommissionsCRUDAPI(shiftId), payload);

const updateTeamCommissions = (shiftId, payload) =>
  authenticated(insighttAPI).put(shiftsEndpoints.teamCommissionsCRUDAPI(shiftId), payload);

const deleteTeamCommissions = (shiftId) =>
  authenticated(insighttAPI).delete(shiftsEndpoints.teamCommissionsCRUDAPI(shiftId));

const createPerVehicleCommissions = (shiftId, payload) =>
  authenticated(insighttAPI).post(shiftsEndpoints.perVehicleCommissionsCRUDAPI(shiftId), payload);

const updatePerVehicleCommissions = (shiftId, payload) =>
  authenticated(insighttAPI).put(shiftsEndpoints.perVehicleCommissionsCRUDAPI(shiftId), payload);

const deletePerVehicleCommissions = (shiftId) =>
  authenticated(insighttAPI).delete(shiftsEndpoints.perVehicleCommissionsCRUDAPI(shiftId));

const createTimeClock = (shiftId, payload) =>
  authenticated(insighttAPI).post(shiftsEndpoints.createTimeClockAPI(shiftId), payload);

const updateTimeClock = (shiftId, timeClockId, payload) =>
  authenticated(insighttAPI).put(shiftsEndpoints.updateTimeClockAPI(shiftId, timeClockId), payload);

const deleteTimeClock = (shiftId, timeClockId) =>
  authenticated(insighttAPI).delete(shiftsEndpoints.deleteTimeClockAPI(shiftId, timeClockId));

export const shiftsService = {
  getAllShifts,
  getUserShifts,
  getShiftDetails,
  createShift,
  updateShift,
  updateShiftSummary,
  deleteShift,
  createIndividualCommissions,
  updateIndividualCommissions,
  deleteIndividualCommissions,
  createTeamCommissions,
  updateTeamCommissions,
  deleteTeamCommissions,
  createPerVehicleCommissions,
  updatePerVehicleCommissions,
  deletePerVehicleCommissions,
  createTimeClock,
  updateTimeClock,
  deleteTimeClock,
};
